<template>
<div class="chapter">
<div class="inner_page">
<div class="sectionPage">
<h2 class="sectionText sigilNotInTOC" id="heading_id_2">I</h2>
<h2 class="sectionText1" id="heading_id_3"><a id="link1"></a>Early Days</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?290079a2